import React from 'react';
import PropTypes from 'prop-types';

const PaginationInfo = ({resultType, page, total, loading}) => {
  const { number, size } = page;
  const pagePerPageSize = number * size;
  const firstVisibleResultIndex = (number - 1) * size + 1;
  const lastVisibleResultIndex = pagePerPageSize > total ? total : pagePerPageSize;

  return (
    <div className='small text-gray-li margin-top-small'>
      { loading && <span>Loading...</span> }
      { !loading && !total && <span>No {resultType} found</span> }
      {
        !loading && Boolean(total) &&
          <span>
            <span>Showing {resultType} </span>
            <strong>{firstVisibleResultIndex}</strong>
            <span> to </span>
            <strong>{lastVisibleResultIndex}</strong>
            <span> of </span>
            <strong>{ total }</strong>
          </span>
      }
    </div>
  );
};

PaginationInfo.propTypes = {
  resultType: PropTypes.string.isRequired,
  page: PropTypes.shape({
    number: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
  }).isRequired,
  total: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default PaginationInfo;
